// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SubscribedPhotoblogs":"tm_a bie_b bie_bj","SubscribedPhotoblogs__link":"tm_b bie_a bie_r"};